import React from 'react';

import { Field } from 'redux-form';

import { Input, FormText, FormFeedback, Label } from 'reactstrap';

import Select from 'react-select2-wrapper';

const adaptFileEventToValue = delegate => e => delegate(e.target.files[0]);

class CustomInput extends React.Component {
  static defaultProps = {
    component: 'input'
  };

  renderDefault = ({
    input,
    meta: { touched, error, warning, valid },
    ...props
  }) => {
    return (
      <React.Fragment>
        <Input
          invalid={!valid}
          {...(touched ? { valid: valid } : {})}
          {...input}
          {...props}
        />
        {error && <FormFeedback>{error}</FormFeedback>}
        {!error &&
          warning && <FormText className="text-warning">{warning}</FormText>}
      </React.Fragment>
    );
  };

  renderTextArea = ({
    input,
    meta: { touched, error, warning, valid },
    ...props
  }) => {
    return (
      <React.Fragment>
        <Input
          type="textarea"
          invalid={!valid}
          {...(touched ? { valid: valid } : {})}
          {...input}
          {...props}
        />
        {error && <FormFeedback>{error}</FormFeedback>}
        {!error &&
          warning && <FormText className="text-warning">{warning}</FormText>}
      </React.Fragment>
    );
  };

  renderSelect = ({
    input,
    options,
    meta: { touched, error, warning, valid },
    ...props
  }) => {
    const selectOptions = Object.assign({}, options, {
      width: '100%',
      theme: 'bootstrap4',
      minimumResultsForSearch: 5
    });

    return (
      <React.Fragment>
        <Select
          {...(touched ? { valid: valid.toString() } : {})}
          {...input}
          {...props}
          options={selectOptions}
        />
        {error && <FormFeedback>{error}</FormFeedback>}
        {!error &&
          warning && <FormText className="text-warning">{warning}</FormText>}
      </React.Fragment>
    );
  };

  renderCheckbox = ({
    input,
    meta: { touched, error, warning, valid },
    children,
    ...props
  }) => {
    return (
      <React.Fragment>
        <Label check>
          <Input
            type="checkbox"
            invalid={!valid}
            {...(touched ? { valid: valid } : {})}
            {...input}
            {...props}
          />
          {children || ''}
        </Label>
        {error && <FormFeedback>{error}</FormFeedback>}
        {!error &&
          warning && <FormText className="text-warning">{warning}</FormText>}
      </React.Fragment>
    );
  };

  renderFile = ({
    input: { input, onChange, onBlur },
    meta: { touched, error, warning, valid },
    ...props
  }) => {
    return (
      <React.Fragment>
        <Input
          onChange={adaptFileEventToValue(onChange)}
          onBlur={adaptFileEventToValue(onBlur)}
          type="file"
          invalid={!valid}
          {...(touched ? { valid: valid } : {})}
          {...input}
          {...props}
        />
        {error && <FormFeedback>{error}</FormFeedback>}
        {!error &&
          warning && <FormText className="text-warning">{warning}</FormText>}
      </React.Fragment>
    );
  };

  renderField = fieldData => {
    const fd = Object.assign({}, fieldData, {
      component: this.props.component
    });

    switch (fd.component) {
      case 'select':
        return this.renderSelect(fd);

      case 'textarea':
        return this.renderTextArea(fd);

      case 'checkbox':
        return this.renderCheckbox(fd);

      case 'file':
        return this.renderFile(fd);

      default:
        //  text, number, email, password, etc, etc.
        return this.renderDefault(fd);
    }
  };

  render() {
    const { component, ...props } = this.props;

    if (this.props.children) {
      return (
        <Field component={this.renderField} {...props}>
          {this.props.children}
        </Field>
      );
    }

    return <Field component={this.renderField} {...props} />;
  }
}

export default CustomInput;



// WEBPACK FOOTER //
// ./src/components/ui/CustomInput.js